import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.4.1_@types+node@20.12.12_encoding@0.1.13_eslint@8.54.0_iored_veaonuimzkxlz37dwjs5dpu2pm/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}